import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../components-css/navbar.css';
import '../components-css/navbar.mobile.css';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import logo from '../Assets/Images/wicsepedia_logo.png';

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      auth.currentUser?.reload().then(() => {
        if (auth.currentUser?.emailVerified) {
          clearInterval(interval);
          setUser(auth.currentUser);
        } else {
          setUser(null);
        }
      });
    }, 300);

    return () => clearInterval(interval);
  }, [auth, navigate]);

  const handleSignOn = () => {
    navigate("/userAuth");
    setIsMenuOpen(false); // Close menu after navigation
  };

  
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setIsMenuOpen(false); // Close menu after sign out
      console.log('User signed out successfully!');
    } catch (error) {
      console.error('Error signing out:', error); 
    }
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking on mobile overlay
  const handleOverlayClick = () => {
    setIsMenuOpen(false);
  };

  return (
    
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="logo-link" onClick={() => setIsMenuOpen(false)}>
          <div className="logo-container">
            <img src={logo} alt="WiCSEpedia logo"/>
            <div className='logo-name'>
              <div>WiCSE</div>
              <div style={{color: '#2C2931'}}>pedia</div>
            </div>
          </div>
        </Link>
      </div>

      {/* Hamburger menu button */}
      <button className="menu-toggle" onClick={toggleMenu}
        aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isMenuOpen}
        aria-controls="main-navigation"
      >
        <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </span>
      </button>

      {/* Mobile menu overlay */}
      {isMenuOpen && (
        <div className="mobile-overlay" onClick={handleOverlayClick}></div>
      )}

      {/* Navigation links - will be hidden on mobile until menu is opened */}
      <div id="main-navigation" className={`navbar-center ${isMenuOpen ? 'show' : ''}`}>
        <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>Home</Link>
        <Link to="/list" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contribute Data</Link>
        {user && (
          <Link to="/saved" className="nav-link" onClick={() => setIsMenuOpen(false)}>View Database</Link>
        )}
        {user && (
          <Link to="/profile" className="nav-link" onClick={() => setIsMenuOpen(false)}>Profile</Link>
        )}
      </div>

      <div className={`navbar-right ${isMenuOpen ? 'show' : ''}`}>
        {user ? (
          <button onClick={handleSignOut}>Sign Out</button>
        ) : (
          <button onClick={handleSignOn}>Sign In</button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;